import * as i0 from '@angular/core';
import { Injectable, Component, InjectionToken, Inject, LOCALE_ID, NgModule } from '@angular/core';
import * as Rx from 'rxjs';
import { Subject, BehaviorSubject } from 'rxjs';
import { filter, map, flatMap, tap } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpParams, HttpHeaders, HTTP_INTERCEPTORS } from '@angular/common/http';
import * as agent from 'superagent';
import * as moment from 'moment';
import { Big } from 'big.js';
import * as i1$1 from '@angular/router';
import * as i1$2 from '@angular/cdk/overlay';
import { OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
let WebCoreService = /*#__PURE__*/(() => {
  class WebCoreService {
    constructor() {}
    log(message) {}
  }
  WebCoreService.ɵfac = function WebCoreService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WebCoreService)();
  };
  WebCoreService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: WebCoreService,
    factory: WebCoreService.ɵfac,
    providedIn: "root"
  });
  return WebCoreService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WebCoreComponent = /*#__PURE__*/(() => {
  class WebCoreComponent {
    constructor() {}
    ngOnInit() {}
  }
  WebCoreComponent.ɵfac = function WebCoreComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WebCoreComponent)();
  };
  WebCoreComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: WebCoreComponent,
    selectors: [["lib-web-core"]],
    decls: 2,
    vars: 0,
    template: function WebCoreComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "p");
        i0.ɵɵtext(1, " web-core works! ");
        i0.ɵɵelementEnd();
      }
    },
    encapsulation: 2
  });
  return WebCoreComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const API_CONFIG = new InjectionToken("config");
let NotificationService = /*#__PURE__*/(() => {
  class NotificationService {
    constructor() {
      this.subject = new Subject();
    }
    post(name, value) {
      this.subject.next([name, value]);
    }
    register(name) {
      return this.subject.pipe(filter(i => i[0] === name)).pipe(map(i => i[1]));
    }
  }
  NotificationService.ɵfac = function NotificationService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NotificationService)();
  };
  NotificationService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NotificationService,
    factory: NotificationService.ɵfac,
    providedIn: 'root'
  });
  return NotificationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const AFTER_USER_LOGIN = 'AFTER_USER_LOGIN';
const AFTER_USER_LOGOUT = 'AFTER_USER_LOGOUT';
const USER_EMAIL_VERIFIED = 'USER_EMAIL_VERIFIED';
const OPEN_DRAWER = 'OPEN_DRAWER';
const AFTER_ORDER_CREATED = 'AFTER_ORDER_CREATED';
const TURN_ON_SYSTEM_PROXY = 'TURN_ON_SYSTEM_PROXY';
const TURN_OFF_SYSTEM_PROXY = 'TURN_OFF_SYSTEM_PROXY';
const AFTER_TRANSFER_FUND = 'AFTER_TRANSFER_FUND';
const AFTER_RELOAD_FUND = 'AFTER_RELOAD_FUND';
const CHANGE_SERVICE = 'CHANGE_SERVICE';
const AFTER_INVOICE_DEDUCT = 'AFTER_INVOICE_DEDUCT';
const WINDOW_SRCOLL = 'WINDOW_SRCOLL';
const AFTER_USER_PAID = 'AFTER_USER_PAID';
const AFTER_INVOICE_CANCEL = 'AFTER_INVOICE_CANCEL';
const AFTER_INVOICE_PAID = 'AFTER_INVOICE_PAID';
class User {}
var OauthType = /*#__PURE__*/function (OauthType) {
  OauthType["SIGNIN"] = "signin";
  OauthType["SIGNUP"] = "signup";
  return OauthType;
}(OauthType || {});
let CoreEventService = /*#__PURE__*/(() => {
  class CoreEventService {
    constructor() {
      this.subject = new Subject();
    }
    post(name, value) {
      this.subject.next([name, value]);
    }
    register(name) {
      return this.subject.pipe(filter(i => i[0] === name), map(i => i[1]));
    }
  }
  CoreEventService.ɵfac = function CoreEventService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CoreEventService)();
  };
  CoreEventService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CoreEventService,
    factory: CoreEventService.ɵfac,
    providedIn: 'root'
  });
  return CoreEventService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
// 定义核心事件常量
const CORE_EVENTS = {
  AFTER_USER_LOGIN: 'AFTER_USER_LOGIN',
  AFTER_USER_LOGOUT: 'AFTER_USER_LOGOUT',
  USER_EMAIL_VERIFIED: 'USER_EMAIL_VERIFIED',
  OPEN_DRAWER: 'OPEN_DRAWER',
  AFTER_ORDER_CREATED: 'AFTER_ORDER_CREATED',
  TURN_ON_SYSTEM_PROXY: 'TURN_ON_SYSTEM_PROXY',
  TURN_OFF_SYSTEM_PROXY: 'TURN_OFF_SYSTEM_PROXY',
  AFTER_TRANSFER_FUND: 'AFTER_TRANSFER_FUND',
  AFTER_RELOAD_FUND: 'AFTER_RELOAD_FUND',
  CHANGE_SERVICE: 'CHANGE_SERVICE',
  AFTER_INVOICE_DEDUCT: 'AFTER_INVOICE_DEDUCT',
  WINDOW_SRCOLL: 'WINDOW_SRCOLL',
  AFTER_USER_PAID: 'AFTER_USER_PAID'
};
class InvoicePage {}
class InvoiceDto {}
class InvoiceItem {
  constructor(id, description, amount, duedate, type) {
    this.id = id;
    this.description = description;
    this.amount = amount;
    this.duedate = duedate;
    this.type = type;
  }
  static fromData(data) {
    return new InvoiceItem(data.id, data.description, data.amount, data.duedate, data.type);
  }
  getDueDate() {
    return new Date(this.duedate);
  }
  getAmountAsNumber() {
    return parseFloat(this.amount);
  }
  getDeductionType() {
    if (this.description.includes('Deduction')) {
      switch (this.description.split(' ')[0]) {
        case 'Coupon':
          return DeductionType.voucher;
        case 'Code':
          return DeductionType.discount_code;
        // this.discountCode = deductionItems[0].description.split(' ')[2]
        case 'Balance':
          return DeductionType.balance;
        default:
          return DeductionType.none;
      }
    } else {
      return DeductionType.none;
    }
  }
}
class Invoice {
  constructor(description, duedate, status, total, serviceId, datepaid, id, nextDueDate, serviceStatus, items) {
    if (id) {
      this.id = id;
    }
    if (nextDueDate) {
      this.nextDueDate = nextDueDate;
    }
    if (serviceStatus) {
      this.serviceStatus = serviceStatus;
    }
    this.description = description;
    this.duedate = duedate;
    this.status = status;
    this.total = total;
    this.serviceId = serviceId;
    this.datepaid = datepaid;
    this.items = items;
  }
  static fromData(data) {
    if (!data) {
      return null;
    }
    const {
      description,
      duedate,
      status,
      total,
      serviceId,
      datepaid,
      id,
      nextDueDate,
      serviceStatus,
      items
    } = data;
    const _items = items?.map(item => InvoiceItem.fromData(item));
    return new Invoice(description, duedate, status, total, serviceId, datepaid, id, nextDueDate, serviceStatus, _items);
  }
  daysTillDue() {
    return moment.duration(moment.utc(this.nextDueDate).diff(moment.utc())).asDays();
  }
  isDue() {
    // in frontend only due after 2 days, so the newly invoice can have more chance to get paid
    return this.daysTillDue() < -2 && this.status !== 'Paid';
  }
  hadDiscount() {
    return this.items?.some(item => item.getDeductionType() !== DeductionType.none);
  }
}
var DeductionType = /*#__PURE__*/function (DeductionType) {
  DeductionType["balance"] = "BALANCE";
  DeductionType["voucher"] = "VOUCHER";
  DeductionType["discount_code"] = "DISCOUNT_CODE";
  DeductionType["none"] = "NONE";
  return DeductionType;
}(DeductionType || {});
var BuyType = /*#__PURE__*/function (BuyType) {
  BuyType[BuyType["SERVICE"] = 1] = "SERVICE";
  BuyType[BuyType["FLOWDATA"] = 2] = "FLOWDATA";
  BuyType[BuyType["TRIAL"] = 3] = "TRIAL";
  return BuyType;
}(BuyType || {});
var RouterBuyType = /*#__PURE__*/function (RouterBuyType) {
  RouterBuyType["SERVICE"] = "service";
  RouterBuyType["FLOWDATA"] = "flowdata";
  return RouterBuyType;
}(RouterBuyType || {});
class Service {
  constructor(name, nextduedate, status, billingcycle, productId, subscriptionUrl, usage, resetDate, id, firstpaymentamount, recurringamount) {
    if (id) {
      this.id = id;
    }
    this.name = name;
    this.nextduedate = nextduedate;
    this.status = status;
    this.billingcycle = billingcycle;
    this.productId = productId;
    this.subscriptionUrl = subscriptionUrl;
    this.usage = usage;
    this.resetDate = resetDate;
    this.firstpaymentamount = firstpaymentamount;
    this.recurringamount = recurringamount;
  }
  static fromData(data) {
    const {
      id,
      name,
      usage,
      nextduedateBuf,
      status,
      billingcycle,
      productId,
      subscriptionUrl,
      resetDate,
      firstpaymentamount,
      recurringamount
    } = data;
    return new Service(name, nextduedateBuf, status, billingcycle, productId, subscriptionUrl, usage, resetDate, id, firstpaymentamount, recurringamount);
  }
  daysTillDue() {
    if (!this.nextduedate) {
      return 0;
    }
    return moment.duration(moment.utc(this.nextduedate).diff(moment.utc())).asDays();
  }
  timeTillDue() {
    if (!this.nextduedate) {
      return `0 天`;
    }
    let dueHour = moment.utc(this.nextduedate).local().diff(moment.utc(), "hours");
    if (dueHour < 0) {
      return `0 天`;
    } else if (dueHour < 1) {
      return `${moment.utc(this.nextduedate).local().diff(moment.utc(), "minutes")} 分钟`;
    } else if (dueHour < 24) {
      return `${dueHour} 小时`;
    } else {
      return `${(dueHour / 24).toFixed(0)} 天`;
    }
  }
  isDue() {
    return this.daysTillDue() < 0;
  }
  usageCapInGB() {
    if (!this.usage) {
      return "0";
    }
    return new Big(Number(this.usage.allowed)).div(1073741824).toFixed(0);
  }
  used() {
    if (!this.usage) {
      return "0";
    }
    if (+this.usage.allowed === 0) {
      return "0";
    }
    return new Big(this.usage.upload + this.usage.download).div(new Big(Number(this.usage.allowed))).times(100).toFixed(2);
  }
  overUsed() {
    if (!this.usage) {
      return false;
    }
    return new Big(this.usage.upload + this.usage.download).gte(new Big(Number(this.usage.allowed)));
  }
  overUsedInGB() {
    if (!this.usage) {
      return "0";
    }
    return new Big(Number(this.usage.allowed)).minus(new Big(this.usage.upload + this.usage.download)).div(1073741824).toFixed(0);
  }
  speedLimit() {
    const qutoa = this.overUsedInGB();
    if (+qutoa >= 200) {
      return 15;
    }
    if (+qutoa >= 100) {
      return 10;
    }
    if (+qutoa >= 50) {
      return 5;
    }
    return 0;
  }
  speedLimitByProductId() {
    return this.productId === 1 ? 5 : this.productId === 2 ? 10 : 15;
  }
  terminated() {
    return this.status === "Terminated";
  }
  countResetDay() {
    return moment.utc(this.resetDate).local().diff(moment.utc(), "days");
  }
  countRestTime() {
    let resetHour = moment.utc(this.resetDate).local().diff(moment.utc(), "hours");
    if (resetHour < 0) {
      return `0 天`;
    } else if (resetHour < 1) {
      return `${moment.utc(this.resetDate).local().diff(moment.utc(), "minutes")} 分钟`;
    } else if (resetHour < 24) {
      return `${resetHour} 小时`;
    } else {
      return `${(resetHour / 24).toFixed(0)} 天`;
    }
  }
  // new methods from next version
  getNextduedate() {
    if (this.nextduedate) {
      return moment.utc(this.nextduedate).format("yyyy.MM.DD");
    }
    return "";
  }
  remainingInGB() {
    if (!this.usage) {
      return '0';
    }
    return new Big(Number(this.usage.allowed)).minus(new Big(this.usage.upload + this.usage.download)).div(1073741824).toFixed(2);
  }
  remaining() {
    if (!this.usage) {
      return 0;
    }
    return new Big(100).minus(new Big(this.usage?.upload + this.usage?.download).div(new Big(Number(this.usage.allowed))).times(100)).toFixed(2);
  }
  countResetDayPercentage() {
    const daysDifference = this.countResetDay();
    return (daysDifference / 30 * 100).toFixed(0);
  }
  getRegdate() {
    if (this.resetDate) {
      return moment.utc(new Date(this.resetDate)).local().format("YYYY年MM月DD号 HH:mm");
    }
    return "";
  }
}
class Server {
  constructor(name, host, port, status, country, description, type, probe, tags, username, password, uuid, serviceId, id) {
    this.latency = '-- ms';
    if (id) {
      this.id = id;
    }
    this.name = name;
    this.host = host;
    this.port = port;
    this.status = status;
    this.country = country || this.name.match(/[A-Z]+/g).pop();
    this.description = description;
    this.type = type;
    this.probe = probe;
    this.tags = tags;
    this.username = username;
    this.password = password;
    this.uuid = uuid;
    this.serviceId = serviceId;
    this.localId = `${serviceId} - ${id}`;
  }
  static fromData(data) {
    const {
      name,
      host,
      port,
      status,
      country,
      description,
      type,
      probe,
      tags,
      username,
      password,
      uuid,
      serviceId,
      id
    } = data;
    return new Server(name, host, port, status, country, description, type, probe, tags, username, password, uuid, serviceId, id);
  }
  ping() {
    const start = Date.now();
    fetch(`https://${this.host}:${this.port}`, {
      mode: 'no-cors',
      cache: 'no-store'
    }).then(() => {
      const latency = Math.round(Date.now() - start);
      this.latency = `${latency} ms`;
    }).catch(error => {
      this.latency = 'failed';
    });
  }
}
class Product {
  constructor(gid, name, description, pricing, id) {
    this.gid = gid;
    this.name = name;
    this.description = description;
    this.pricing = pricing;
    this.id = id;
    this.currency = this._getFirstAvailableCurrency() || 'HKD';
  }
  static fromData(data) {
    const {
      gid,
      name,
      description,
      pricing,
      id
    } = data;
    return new Product(gid, name, description, pricing, id);
  }
  _getFirstAvailableCurrency() {
    if (this.pricing && typeof this.pricing === 'object') {
      const availableCurrencies = Object.keys(this.pricing);
      if (availableCurrencies.length > 0) {
        return availableCurrencies[0];
      }
    }
    return undefined;
  }
  // calculate the saved amount if user choose to pay other than monthly
  calculateSaved(billingCycle) {
    if (!billingCycle || !this.pricing?.[this.currency]) {
      return null;
    }
    try {
      let pricePaidByMonth;
      let price;
      switch (billingCycle) {
        case "monthly":
          pricePaidByMonth = new Big(this.pricing[this.currency].monthly);
          price = new Big(this.pricing[this.currency].monthly);
          break;
        case "quarterly":
          pricePaidByMonth = new Big(this.pricing[this.currency].monthly).times(3);
          price = new Big(this.pricing[this.currency].quarterly);
          break;
        case "semiannually":
          pricePaidByMonth = new Big(this.pricing[this.currency].monthly).times(6);
          price = new Big(this.pricing[this.currency].semiannually);
          break;
        case "annually":
          pricePaidByMonth = new Big(this.pricing[this.currency].monthly).times(12);
          price = new Big(this.pricing[this.currency].annually);
          break;
        case "biennially":
          pricePaidByMonth = new Big(this.pricing[this.currency].monthly).times(24);
          price = new Big(this.pricing[this.currency].biennially);
          break;
        default:
          return null;
      }
      return {
        pricePaidByMonth,
        saved: pricePaidByMonth.minus(price).div(pricePaidByMonth).times(100),
        price
      };
    } catch (error) {
      return null;
    }
  }
  getMonthlyAmount(cycles) {
    let amount = "";
    const currency = this.pricing?.[this.currency];
    if (currency && currency[cycles]) {
      switch (cycles) {
        case "quarterly":
          amount = new Big(currency[cycles]).div(3).toFixed(2);
          break;
        case "semiannually":
          amount = new Big(currency[cycles]).div(6).toFixed(2);
          break;
        case "annually":
          amount = new Big(currency[cycles]).div(12).toFixed(2);
          break;
        default:
          amount = currency[cycles];
          break;
      }
    }
    return amount;
  }
  getAmountByBillingCycle(cycles) {
    return this.pricing?.[this.currency][cycles];
  }
  getSaveAmount(cycles) {
    return this.calculateSaved(cycles)?.saved.toFixed(0);
  }
}
class RewardInvitDto {}
class RewardPageDto {}
var RewardStatus = /*#__PURE__*/function (RewardStatus) {
  RewardStatus["CLAIMED"] = "CLAIMED";
  RewardStatus["USED"] = "USED";
  RewardStatus["EXPIRED"] = "EXPIRED";
  return RewardStatus;
}(RewardStatus || {});
class Reward {
  constructor(data) {
    Object.assign(this, data);
  }
  static fromData(data) {
    return new Reward({
      id: data.id,
      title: data.title,
      award: data.award,
      status: data.status,
      note: data.note,
      invoiceId: data.invoiceId
    });
  }
}
let APIManager = /*#__PURE__*/(() => {
  class APIManager {
    constructor(http, config) {
      this.http = http;
      this.config = config;
      this.nodeApiBaseUrl = "http://localhost:10087";
      this.validateConfig(config);
      this.serverUrl = this.config.apiUrl;
    }
    validateConfig(config) {
      // if (!config.apiUrl) {
      //   throw new Error("ApiConfig: apiUrl is required");
      // }
      // 其他验证...
    }
    fetchUser() {
      return this.http.get(`${this.serverUrl}/api/v1/users/info`);
    }
    fetchServices(source) {
      let url = this.serverUrl + "/api/v1/services";
      if (source) {
        url = url + "?from=" + source;
      }
      return this.http.get(url).pipe(flatMap(async data => {
        const services = data.map(s => Service.fromData(s));
        return services;
      }));
    }
    fetchServers(service) {
      let url = `${this.serverUrl}/api/v1/services/${service.id}/servers`;
      if (`${service.id}` === "sample") {
        url = `${this.serverUrl}/api/v1/open/servers`;
      }
      return this.http.get(url).pipe(flatMap(async data => {
        const servers = data.map(s => Server.fromData(s));
        return servers;
      }));
    }
    fetchServiceDetail(service, source) {
      let url = `${this.serverUrl}/api/v1/services/${service.id}`;
      if (source) {
        url = url + "?from=" + source;
      }
      return this.http.get(url).pipe(flatMap(async data => {
        const service = Service.fromData(data);
        return service;
      }));
    }
    upgradeService(serviceId, body) {
      return this.http.post(`${this.serverUrl}/api/v1/services/${serviceId}/upgrade`, body);
    }
    updateBillingCycle(serviceId, body) {
      return this.http.post(`${this.serverUrl}/api/v1/services/${serviceId}/update`, body);
    }
    deleteService(serviceId) {
      return this.http.get(`${this.serverUrl}/api/v1/services/${serviceId}/delete`);
    }
    fetchConfigFile(service) {
      return this.http.get(`${service.subscriptionUrl}?client=jetstream`, {
        responseType: "text"
      });
    }
    fetchInvoices(pageInfo) {
      const params = {
        limitstart: pageInfo.limitstart?.toString() || "0",
        limitnum: pageInfo.limitnum?.toString() || "10",
        orderby: pageInfo.orderby || "id",
        order: pageInfo.order || "desc",
        status: pageInfo.status || "Paid"
      };
      const queryParams = new HttpParams({
        fromObject: params
      });
      return this.http.get(`${this.serverUrl}/api/v1/invoices`, {
        params: queryParams
      }).pipe(flatMap(async data => {
        const invoices = data.map(i => Invoice.fromData(i));
        return invoices;
      }));
    }
    fetchInvoicesByPage(pageInfo) {
      return this.http.post(`${this.serverUrl}/api/v1/invoices/page`, pageInfo);
    }
    fetchInvoiceDetail(id) {
      return this.http.get(`${this.serverUrl}/api/v1/invoices/${id}`);
    }
    fetchProducts() {
      return this.http.get(`${this.serverUrl}/api/v1/products`).pipe(flatMap(async data => {
        const products = data.map(p => Product.fromData(p));
        return products;
      }));
    }
    createOrder(product, billingcycle, promoCode) {
      return this.http.post(`${this.serverUrl}/api/v1/orders`, {
        productId: product.id,
        billingcycle,
        promoCode
      });
    }
    payInvoice(invoice, method, paymentMethodId) {
      return this.http.get(`${this.serverUrl}/api/v1/invoices/${invoice.id}/pay?paymentMethod=${method}${paymentMethodId ? "&paymentMethodId=" + paymentMethodId : ""}`);
    }
    deductionInvoice(invoice, amount, rewardsid, dcCode, billingCycle, flowdata = false) {
      return this.http.post(`${this.serverUrl}/api/v1/invoices/${invoice.id}/deduct`, {
        amount: Number(amount),
        flowdata,
        rewardsid: Number(rewardsid),
        dcCode,
        billingCycle
      });
    }
    regenerateInvoice(invoice, force = false) {
      let url = `${this.serverUrl}/api/v1/invoices/${invoice.id}/regenerate`;
      if (force) {
        url = url + "?force=1";
      }
      return this.http.get(url);
    }
    fetchLatestInvoice(service) {
      return this.http.get(`${this.serverUrl}/api/v1/services/${service.id}/latest`).pipe(flatMap(async data => {
        const invoice = Invoice.fromData(data);
        return invoice;
      }));
    }
    fetchLatestFlowInvoice(service) {
      return this.http.get(`${this.serverUrl}/api/v1/invoices/${service.id}/flow_latest`).pipe(flatMap(async data => {
        const invoice = Invoice.fromData(data);
        return invoice;
      }));
    }
    cancelInvoice(invoiceId) {
      return this.http.get(`${this.serverUrl}/api/v1/invoices/${invoiceId}/cancel`);
    }
    createUser(user) {
      return this.http.post(`${this.serverUrl}/api/v1/users`, user);
    }
    updateUTM(utm) {
      return this.http.post(`${this.serverUrl}/api/v1/users/utm`, utm);
    }
    isUserTried() {
      return this.http.get(`${this.serverUrl}/api/v1/invoices/isTrial`);
    }
    createTrialOrder(productId, paymentMethod) {
      return this.http.post(`${this.serverUrl}/api/v1/orders/trial`, {
        productId,
        billingcycle: "monthly",
        paymentMethod
      });
    }
    resendEmail() {
      return this.http.get(`${this.serverUrl}/api/v1/users/verify/resend`);
    }
    emailcheck(email) {
      return this.http.get(`${this.serverUrl}/api/v2/users/emailcheck?email=${email}`);
    }
    login(email, password) {
      return this.http.post(`${this.serverUrl}/api/v1/users/login`, {
        email,
        password
      });
    }
    redirect(target) {
      this.http.get(`${this.serverUrl}/api/v1/users/redirect/${target}`).subscribe(value => {
        window.open(`${value["target"]}`, "_blank");
      });
    }
    proxyApp(platform) {
      return this.http.get(`${this.serverUrl}/api/v1/apps/FlashVPN/release/${platform}`);
    }
    /**
     * Get App By App Center
     * @param platform
     */
    getAppLinkByAppCenter(platform) {
      return this.http.get(`${this.serverUrl}/api/v1/apps/release/${platform}`);
    }
    /**
     * Get App By GitHub
     * @param platform
     */
    getAppLinkByGitHub(platform) {
      return this.http.get(`${this.serverUrl}/api/v1/apps/release-second/${platform}`);
    }
    walletsRule() {
      return this.http.get(`${this.serverUrl}/api/v1/wallets/rule`);
    }
    /**
     * Wallets and Rewards
     */
    /**
     * Get user's wallet
     * @param user
     */
    fetchWallet() {
      return this.http.get(`${this.serverUrl}/api/v1/wallets`);
    }
    /**
     * Get campaigns
     */
    fetchCampaigns() {
      return this.http.get(`${this.serverUrl}/api/v1/campaigns`);
    }
    /**
     * Get user's transactions
     * @param user
     */
    fetchTransactions() {
      return this.http.get(`${this.serverUrl}/api/v1/wallets/transactions`);
    }
    transferFunds(address, amount) {
      return this.http.post(`${this.serverUrl}/api/v1/wallets/transfer`, {
        address,
        amount
      });
    }
    redeemData(service, points) {
      return this.http.post(`${this.serverUrl}/api/v1/services/${service.id}/redeem`, {
        amount: points
      });
    }
    updateUserLanguage(locale) {
      return this.http.post(`${this.serverUrl}/api/v1/users/updateLocale`, {
        locale
      });
    }
    // selectorName = encodeURI('🔰 節點選擇');
    async updateNode(nodeName, selectorName) {
      selectorName = selectorName === "rule" ? "%F0%9F%94%B0%20%E7%AF%80%E9%BB%9E%E9%81%B8%E6%93%87" : "GLOBAL";
      return await agent.put(`${this.nodeApiBaseUrl}/proxies/${selectorName}`).send({
        name: nodeName
      });
    }
    async updateMode(mode) {
      return agent.patch(`${this.nodeApiBaseUrl}/configs`).send({
        mode
      });
    }
    getClashMode() {
      return agent.get(`${this.nodeApiBaseUrl}/configs`);
    }
    async getConnections() {
      return await agent.get(`${this.nodeApiBaseUrl}/connections`);
    }
    async deleteConnection(connectionId) {
      return await agent.delete(`${this.nodeApiBaseUrl}/connections/${connectionId}`);
    }
    fetchWalletsRule() {
      return this.http.get(`${this.serverUrl}/api/v1/wallets/rule`);
    }
    createBalanceInvoices(invoices) {
      return this.http.post(`${this.serverUrl}/api/v1/invoices`, invoices);
    }
    payBalanceInvoice(invoiceid, method, token) {
      return this.http.get(`${this.serverUrl}/api/v1/invoices/${invoiceid}/pay?paymentMethod=${method}&token=${token}`);
    }
    activities() {
      return this.http.get(`${this.serverUrl}/api/v1/activities/awake`);
    }
    awake(serviceId) {
      const url = serviceId ? `${this.serverUrl}/api/v1/services/${serviceId}/awake` : `${this.serverUrl}/api/v1/services/awake`;
      return this.http.get(url);
    }
    getFlowdataRule() {
      return this.http.get(`${this.serverUrl}/api/v1/flowdata/rule`);
    }
    createFlowInvoice(invoices) {
      return this.http.post(`${this.serverUrl}/api/v1/invoices/createFlowInvoice`, invoices).pipe(flatMap(async data => {
        const invoice = Invoice.fromData(data);
        return invoice;
      }));
    }
    wakeUp(serviceId, activityId) {
      return this.http.post(`${this.serverUrl}/api/v1/services/${serviceId}/wake`, {
        activityId
      });
    }
    getActivityInfo(activityId = 1) {
      return this.http.get(`${this.serverUrl}/api/v1/activities/${activityId}`);
    }
    getTgBindCode() {
      return this.http.get(`${this.serverUrl}/api/v1/users/tg`);
    }
    getHelpsCategories() {
      return this.http.get(`${this.serverUrl}/cms/categories`);
    }
    getHelpsArticles(params) {
      let str = "";
      if (params && params.id !== undefined) {
        str = `/${params.id}`;
      }
      return this.http.get(`${this.serverUrl}/cms/articles${str}`);
    }
    getHelpsArticlesByShow() {
      return this.http.get(`${this.serverUrl}/cms/articles?filters[show_on_service_page]=true`);
    }
    getInvitRewardsByPage(pageInfo) {
      return this.http.post(`${this.serverUrl}/api/v1/rewards/getInvitRewardsByPage`, pageInfo);
    }
    getInvitRewardInfo() {
      return this.http.get(`${this.serverUrl}/api/v1/rewards/getInvitRewardInfo`);
    }
    sendInviteEmail(email) {
      return this.http.get(`${this.serverUrl}/api/v1/users/invite/send?email=${email}`);
    }
    uploadFcmToken(token) {
      return this.http.post(`${this.serverUrl}/api/v1/users/fcm`, {
        token
      });
    }
    getMessageClient() {
      return this.http.get(`${this.serverUrl}/api/v1/messages/client`);
    }
    getClientWelfareRule() {
      return this.http.get(`${this.serverUrl}/api/v1/welfare/getClientRule`);
    }
    getMileageWelfareRule() {
      return this.http.get(`${this.serverUrl}/api/v1/welfare/getMileageRule`);
    }
    getCommunityRule() {
      return this.http.get(`${this.serverUrl}/api/v1/welfare/getCommunityRule`);
    }
    receiveWelfare(ruleId, type) {
      return this.http.post(`${this.serverUrl}/api/v1/welfare/receiveWelfare`, {
        ruleId,
        type
      });
    }
    getRewardsByUser() {
      return this.http.get(`${this.serverUrl}/api/v1/rewards/getRewardsByUser`).pipe(flatMap(async data => {
        const rewards = data.map(r => Reward.fromData(r));
        return rewards;
      }));
    }
    getCountByUser() {
      return this.http.get(`${this.serverUrl}/api/v1/rewards/getCountByUser`);
    }
    verifyDcCode(code, billingCycle, serviceId) {
      return this.http.post(`${this.serverUrl}/api/v1/invoices/verifyDcCode`, {
        code,
        billingCycle,
        serviceId
      });
    }
    claim(serviceId, type, date) {
      return this.http.post(`${this.serverUrl}/api/v1/services/${serviceId}/claim`, {
        type,
        date
      });
    }
    trialInfo() {
      return this.http.get(`${this.serverUrl}/api/v2/products/trail`);
    }
    verifyEmail(code, email) {
      const refreshToken = localStorage.getItem("refresh_token");
      const httpOptions = {
        headers: new HttpHeaders({
          authorization: `Bearer ${refreshToken}`
        })
      };
      return this.http.get(`${this.serverUrl}/api/v1/users/verify/${code}/${email}`, httpOptions);
    }
    resetPassword(verifyCode, password) {
      return this.http.post(`${this.serverUrl}/api/v1/users/resetpassword/verify/${verifyCode}`, {
        password,
        confirmedPassword: password
      });
    }
    sendResetPasswordEmail(email, redirectTo) {
      return this.http.post(`${this.serverUrl}/api/v1/users/resetpassword`, {
        email,
        redirectTo
      });
    }
    getApiUrl() {
      return this.config.apiUrl;
    }
    getDeliveryIPs() {
      return this.http.get(`${this.serverUrl}/api/v1/apps/ips`);
    }
    getDeliveryDomains(host) {
      return this.http.get(`${this.serverUrl}/api/v1/apps/dns-info?host=${this.config.frontDomain}`);
    }
    getAppVersion(platform) {
      return this.http.get(`${this.serverUrl}/api/v1/apps/release/${platform}`);
    }
  }
  APIManager.ɵfac = function APIManager_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || APIManager)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_CONFIG));
  };
  APIManager.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: APIManager,
    factory: APIManager.ɵfac,
    providedIn: "root"
  });
  return APIManager;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UsersService = /*#__PURE__*/(() => {
  class UsersService {
    constructor(eventService, apiManager) {
      this.eventService = eventService;
      this.apiManager = apiManager;
      this.user$ = new BehaviorSubject(null);
      if (this.isTokenSaved()) {
        this.reloadUser();
      }
    }
    isTokenSaved() {
      return localStorage.getItem("token") !== null;
    }
    async isLoggedIn() {
      const u = await this.currentUser();
      return u !== undefined;
    }
    // fetch user from db if not in memory
    async currentUser() {
      if (this.user === undefined) {
        await this.reloadUser();
      }
      return this.user;
    }
    // save user token to db
    async login(token, email) {
      const user = new User();
      user.token = token;
      user.email = email;
      await this.loginByUser(user);
      await this.reloadUser();
    }
    async loginByUser(user) {
      localStorage.setItem("token", user.token);
      this.user = user;
      this.user$.next(this.user);
      this.eventService.post(CORE_EVENTS.AFTER_USER_LOGIN, user.token);
    }
    // clear out all db related to logged user
    async logout() {
      delete this.user;
      this.user$.next(null);
      // reset current server
      localStorage.removeItem("token");
      localStorage.removeItem("currentService");
      localStorage.removeItem("currentServer");
      // logout for chatwoot
      // @ts-ignore
      window?.$chatwoot?.reset();
    }
    // fetch user info from server
    async reloadUser() {
      try {
        let user = await this.apiManager.fetchUser().toPromise();
        let token = localStorage.getItem("token");
        if (!!token && !!user) {
          user.token = token;
          await this.loginByUser(user);
        }
      } catch (e) {}
    }
    /**
     * call signup again to trigger verification email
     */
    async resendEmail() {
      try {
        await this.apiManager.resendEmail().toPromise();
      } catch (e) {}
    }
    async setUtm(data) {
      if (data.utmSource) {
        localStorage.setItem("utmSource", data.utmSource);
      }
      if (data.utmMedium) {
        localStorage.setItem("utmMedium", data.utmMedium);
      }
      if (data.utmCampaign) {
        localStorage.setItem("utmCampaign", data.utmCampaign);
      }
      if (data.utmTerm) {
        localStorage.setItem("utmTerm", data.utmTerm);
      }
      if (data.utmContent) {
        localStorage.setItem("utmContent", data.utmContent);
      }
    }
    removeUtm() {
      localStorage.removeItem("utmSource");
      localStorage.removeItem("utmMedium");
      localStorage.removeItem("utmCampaign");
      localStorage.removeItem("utmTerm");
      localStorage.removeItem("utmContent");
    }
  }
  UsersService.ɵfac = function UsersService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UsersService)(i0.ɵɵinject(CoreEventService), i0.ɵɵinject(APIManager));
  };
  UsersService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UsersService,
    factory: UsersService.ɵfac,
    providedIn: "root"
  });
  return UsersService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AuthInterceptor = /*#__PURE__*/(() => {
  class AuthInterceptor {
    constructor(localeId, injector, router, route, notification) {
      this.localeId = localeId;
      this.injector = injector;
      this.router = router;
      this.route = route;
      this.notification = notification;
    }
    intercept(req, next) {
      // Get the auth token from the service.
      const token = localStorage.getItem("token");
      return Rx.of(token).pipe(flatMap(token => {
        // Clone the request and replace the original headers with
        // cloned headers, updated with the authorization.
        let headers = req.headers;
        // auth
        if (!!token) {
          headers = headers.set("Authorization", `Bearer ${token}`);
        }
        // locale
        headers = headers.set("Content-Language", this.localeId);
        let clonedReq;
        if (req.url.indexOf("/cms/") < 0) {
          clonedReq = req.clone({
            headers
          });
        } else {
          clonedReq = req; // 不设置请求头
        }
        return next.handle(clonedReq).pipe(tap(event => {
          return event;
        }, async err => {
          if (err.status === 403 && req.url.indexOf("from=helpCenter") < 0) {
            // todo notify token expired
            // this.notification.post(AFTER_USER_LOGOUT);
            if (!!this.injector.get(UsersService)?.user$?.value) {
              await this.router.navigate(["users", "signin"], {
                queryParams: {
                  redirect: this.router.routerState.snapshot.url.split("?")[0],
                  ...this.route.snapshot.queryParams
                }
              });
            }
            if (token) {
              await this.injector.get(UsersService).logout();
            }
            this.notification.post(AFTER_USER_LOGOUT);
          }
        }));
      }));
    }
    get usersService() {
      return this.injector.get(UsersService);
    }
  }
  AuthInterceptor.ɵfac = function AuthInterceptor_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuthInterceptor)(i0.ɵɵinject(LOCALE_ID), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(i1$1.ActivatedRoute), i0.ɵɵinject(NotificationService));
  };
  AuthInterceptor.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AuthInterceptor,
    factory: AuthInterceptor.ɵfac
  });
  return AuthInterceptor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WebCoreModule = /*#__PURE__*/(() => {
  class WebCoreModule {
    static forRoot(config) {
      return {
        ngModule: WebCoreModule,
        providers: [{
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          multi: true
        }, {
          provide: API_CONFIG,
          useValue: config
        }]
      };
    }
  }
  WebCoreModule.ɵfac = function WebCoreModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WebCoreModule)();
  };
  WebCoreModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: WebCoreModule
  });
  WebCoreModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  return WebCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ServiceService = /*#__PURE__*/(() => {
  class ServiceService {
    constructor(apiManager, userService, notification) {
      this.apiManager = apiManager;
      this.userService = userService;
      this.notification = notification;
      this.currentService$ = new BehaviorSubject(null);
      this.serviceInfo$ = new BehaviorSubject(null);
      this.isTried$ = new BehaviorSubject(null);
      this.trialInvoiceId$ = new BehaviorSubject(null);
      this.products$ = new BehaviorSubject(null);
      this.fetchProducts();
      this.getTrialProductInfo();
      this.notification.register(AFTER_USER_PAID).subscribe(async () => {
        await this.checkUserTrial();
      });
      this.userService.user$.pipe(filter(user => !!user), tap(() => {
        this.refreshServiceInfo();
        this.checkUserTrial();
      })).subscribe();
    }
    fetchProducts() {
      return this.apiManager.fetchProducts().pipe(tap(products => {
        this.products$.next(products);
      })).toPromise();
    }
    refreshServiceInfo() {
      const currentServiceId = localStorage.getItem("currentServiceId");
      return this.apiManager.fetchServices().pipe(tap(services => {
        this.serviceInfo$.next(services);
        const selectedService = currentServiceId ? services.find(s => s.id === parseInt(currentServiceId)) : services[0];
        this.setCurrentService(selectedService || services[0]);
      })).toPromise();
    }
    setCurrentService(service) {
      this.currentService$.next(service);
      this.apiManager.fetchServiceDetail(service).subscribe(service => {
        this.currentService$.next(service);
      });
    }
    async checkUserTrial() {
      try {
        const data = await this.apiManager.isUserTried().toPromise();
        this.isTried$.next(data["isTrial"]);
        this.trialInvoiceId$.next(data["invoiceId"]);
        return data;
      } catch (error) {
        console.log(`failed to get isTrial`);
        throw error;
      }
    }
    async getTrialProductInfo() {
      return this.apiManager.trialInfo().toPromise().then(data => {
        localStorage.setItem("trialPrice", data["trialPrice"]);
        localStorage.setItem("trialTraffic", data["trialTraffic"]);
        localStorage.setItem("trialPeriod", data["trialPeriod"]);
        return data;
      });
    }
  }
  ServiceService.ɵfac = function ServiceService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ServiceService)(i0.ɵɵinject(APIManager), i0.ɵɵinject(UsersService), i0.ɵɵinject(NotificationService));
  };
  ServiceService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ServiceService,
    factory: ServiceService.ɵfac,
    providedIn: "root"
  });
  return ServiceService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WalletsService = /*#__PURE__*/(() => {
  class WalletsService {
    constructor(apiManager, usersService, eventService) {
      this.apiManager = apiManager;
      this.usersService = usersService;
      this.eventService = eventService;
      this.wallet$ = new BehaviorSubject(null);
      this.transactions$ = new BehaviorSubject([]);
      this.rechargeList$ = new BehaviorSubject([]);
      /**
       * 获取优惠
       */
      this.getWalletsRule = () => {
        this.apiManager.fetchWalletsRule().pipe(tap(value => {
          this.rechargeList$.next(value);
        })).subscribe();
      };
      this.getWalletsRule();
      this.usersService.user$.pipe(filter(user => !!user), tap(() => this.reloadWallet())).subscribe();
      this.eventService.register(CORE_EVENTS.AFTER_TRANSFER_FUND).subscribe(_ => this.reloadWallet());
    }
    reloadWallet() {
      this.apiManager.fetchWallet().subscribe(value => {
        this.wallet$.next(value);
        this.eventService.post(CORE_EVENTS.AFTER_RELOAD_FUND, value);
      });
      this.apiManager.fetchTransactions().pipe(tap(value => {
        this.transactions$.next(value["records"]);
      })).subscribe();
    }
  }
  WalletsService.ɵfac = function WalletsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WalletsService)(i0.ɵɵinject(APIManager), i0.ɵɵinject(UsersService), i0.ɵɵinject(CoreEventService));
  };
  WalletsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: WalletsService,
    factory: WalletsService.ɵfac,
    providedIn: "root"
  });
  return WalletsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FcmService = /*#__PURE__*/(() => {
  class FcmService {
    constructor(apiManager, userService) {
      this.apiManager = apiManager;
      this.userService = userService;
      this.unreadNum = 0;
      this.messageList = [];
      this.originMessageList = [];
      this.checked = false;
      this.userService.user$.pipe(filter(user => !!user), tap(() => this.getFcm())).subscribe();
    }
    async getFcm() {
      const messageStore = localStorage.getItem("messageListStore");
      this.checked = localStorage.getItem("messageShowRead") === "true";
      let messageStoreArr = [];
      let messageStoreId = [];
      const upExpiredAt = {};
      if (typeof messageStore === "string") {
        messageStoreArr = JSON.parse(messageStore);
      }
      this.apiManager.getMessageClient().subscribe(value => {
        messageStoreId = Array.from(messageStoreArr, item => item.id);
        if (value) {
          value.forEach(element => {
            if (messageStoreId.indexOf(element.id) === -1) {
              element.isRead = false;
              messageStoreArr.push(element);
            } else {
              upExpiredAt[element.id] = element.expiredAt;
            }
          });
        }
        if (Object.keys(upExpiredAt).length > 0) {
          messageStoreArr.forEach(item => {
            item.expiredAt = upExpiredAt[item.id];
          });
        }
        // 剔除失效
        messageStoreArr = messageStoreArr.filter(item => {
          if (!item?.expiredAt) return false;
          const expiredAt = new Date(item.expiredAt);
          return expiredAt > new Date();
        });
        messageStoreArr.sort((a, b) => b.id - a.id);
        // 最多展示20条
        this.originMessageList = messageStoreArr.slice(-20);
        this.messageList = messageStoreArr.slice(-20);
        localStorage.setItem("messageListStore", JSON.stringify(this.messageList));
        this.unreadNum = messageStoreArr.filter(item => !item.isRead).length;
        this.methodOnChange(this.checked);
      });
    }
    handleReadAll() {
      this.originMessageList.forEach(el => {
        el.isRead = true;
      });
      this.messageList = this.originMessageList;
      this.unreadNum = 0;
      localStorage.setItem("messageListStore", JSON.stringify(this.messageList));
    }
    async methodOnChange(e) {
      localStorage.setItem("messageShowRead", e);
      this.checked = e;
      if (e) {
        const arr = [];
        this.originMessageList.forEach(el => {
          if (!el.isRead) {
            arr.push(el);
          }
        });
        this.messageList = arr;
      } else {
        this.messageList = this.originMessageList;
      }
    }
    async handleSwitch(info) {
      this.originMessageList.forEach(el => {
        if (el.id === info.id) {
          el.isRead = true;
        }
      });
      this.unreadNum--;
      this.messageList = this.originMessageList;
      localStorage.setItem("messageListStore", JSON.stringify(this.messageList));
      this.methodOnChange(this.checked);
    }
  }
  FcmService.ɵfac = function FcmService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FcmService)(i0.ɵɵinject(APIManager), i0.ɵɵinject(UsersService));
  };
  FcmService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FcmService,
    factory: FcmService.ɵfac,
    providedIn: "root"
  });
  return FcmService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FlowDataService = /*#__PURE__*/(() => {
  class FlowDataService {
    constructor(http, apiManager) {
      this.http = http;
      this.apiManager = apiManager;
      this.flowData$ = new BehaviorSubject([]);
      this.fetchFlowData();
    }
    fetchFlowData() {
      return this.apiManager.getFlowdataRule().pipe(tap(data => this.flowData$.next(data))).toPromise();
    }
  }
  FlowDataService.ɵfac = function FlowDataService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FlowDataService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(APIManager));
  };
  FlowDataService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: FlowDataService,
    factory: FlowDataService.ɵfac,
    providedIn: "root"
  });
  return FlowDataService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InvoiceService = /*#__PURE__*/(() => {
  class InvoiceService {
    constructor(apiManager, userService) {
      this.apiManager = apiManager;
      this.userService = userService;
      this.invoiceInfo$ = new BehaviorSubject(null);
      this.userService.user$.pipe(filter(user => !!user), tap(() => this.refreshInvoiceInfo())).subscribe();
    }
    refreshInvoiceInfo(invoicePage) {
      if (!invoicePage) {
        invoicePage = {
          limitstart: 0,
          limitnum: 10,
          orderby: "id",
          order: "DESC",
          status: ""
        };
      }
      return this.apiManager.fetchInvoicesByPage(invoicePage).pipe(tap(invoicePage => {
        this.invoiceInfo$.next(invoicePage.invoices);
      }));
    }
  }
  InvoiceService.ɵfac = function InvoiceService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InvoiceService)(i0.ɵɵinject(APIManager), i0.ɵɵinject(UsersService));
  };
  InvoiceService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: InvoiceService,
    factory: InvoiceService.ɵfac,
    providedIn: "root"
  });
  return InvoiceService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PayInfo {}
var PayType = /*#__PURE__*/function (PayType) {
  PayType["WeChat"] = "wechat";
  PayType["AliPay"] = "alipay";
  PayType["Balance"] = "balance";
  PayType["CreditCard"] = "creditcard";
  return PayType;
}(PayType || {});
const payMethodList = [{
  payType: PayType.WeChat,
  imgUrl: 'assets/images/products/wechat.svg',
  payName: '微信支付'
}, {
  payType: PayType.AliPay,
  imgUrl: 'assets/images/products/alipay.svg',
  payName: '支付宝'
}, {
  payType: PayType.Balance,
  imgUrl: 'assets/images/products/balance.svg',
  payName: '余额支付'
}, {
  payType: PayType.CreditCard,
  imgUrl: 'assets/images/products/bank.svg',
  payName: '信用卡支付'
}];
let PaymentMethodService = /*#__PURE__*/(() => {
  class PaymentMethodService {
    constructor(http, config) {
      this.http = http;
      this.config = config;
      this.serverUrl = "";
      this.paymentMethods$ = new BehaviorSubject([]);
      this.currentMethod$ = new BehaviorSubject(null);
      this.serverUrl = config.apiUrl;
      this.fetchPaymentMethods();
    }
    fetchPaymentMethods() {
      this.http.get(`${this.serverUrl}/api/v1/invoices/paymentMethods`).pipe(tap(methods => {
        const filteredMethods = payMethodList.filter(method => methods.includes(method.payType));
        this.paymentMethods$.next(filteredMethods);
        if (filteredMethods.length > 0) {
          this.currentMethod$.next(filteredMethods[0]);
        }
      })).subscribe();
    }
    methodOnChange(event) {
      console.log(event);
    }
  }
  PaymentMethodService.ɵfac = function PaymentMethodService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PaymentMethodService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(API_CONFIG));
  };
  PaymentMethodService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PaymentMethodService,
    factory: PaymentMethodService.ɵfac,
    providedIn: "root"
  });
  return PaymentMethodService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RewardService = /*#__PURE__*/(() => {
  class RewardService {
    constructor(apiManager, userService, notificationService) {
      this.apiManager = apiManager;
      this.userService = userService;
      this.notificationService = notificationService;
      this.inviteRewards$ = new BehaviorSubject(null);
      this.coupons$ = new BehaviorSubject(null);
      this.availableCoupons$ = new BehaviorSubject(null);
      this.countByUser$ = new BehaviorSubject(null);
      this.userService.user$.pipe(filter(user => !!user), tap(() => {
        this.refreshRewardInfo();
        this.getRewards();
      })).subscribe();
      this.notificationService.register(AFTER_INVOICE_CANCEL).subscribe(() => {
        this.refreshRewardInfo();
        this.getRewards();
      });
    }
    refreshRewardInfo() {
      this.apiManager.getInvitRewardInfo().subscribe(rewardInfo => this.inviteRewards$.next(rewardInfo));
    }
    getRewards() {
      return this.apiManager.getRewardsByUser().pipe(tap(rewards => {
        this.coupons$.next(rewards);
        this.availableCoupons$.next(rewards.filter(reward => reward.status === RewardStatus.CLAIMED));
      })).toPromise();
    }
    getCountByUser() {
      return this.apiManager.getCountByUser().pipe(tap(num => this.countByUser$.next(num))).toPromise();
    }
  }
  RewardService.ɵfac = function RewardService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RewardService)(i0.ɵɵinject(APIManager), i0.ɵɵinject(UsersService), i0.ɵɵinject(NotificationService));
  };
  RewardService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RewardService,
    factory: RewardService.ɵfac,
    providedIn: "root"
  });
  return RewardService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WelfareService = /*#__PURE__*/(() => {
  class WelfareService {
    constructor(apiManager, usersService) {
      this.apiManager = apiManager;
      this.usersService = usersService;
      this.clientWelfareRule$ = new BehaviorSubject([]);
      this.mileageWelfareRule$ = new BehaviorSubject([]);
      this.communityRule$ = new BehaviorSubject([]);
      this.receiveWelfare$ = new BehaviorSubject(null);
      this.serviceDays$ = new BehaviorSubject(0);
      this.usersService.user$.pipe(filter(user => !!user), tap(() => this.loadAllWelfareRules())).subscribe();
    }
    loadAllWelfareRules() {
      this.getClientWelfareRule();
      this.getMileageWelfareRule();
      this.getCommunityRule();
    }
    getClientWelfareRule() {
      this.apiManager.getClientWelfareRule().pipe(tap(value => {
        this.clientWelfareRule$.next(value);
      })).subscribe();
    }
    getMileageWelfareRule() {
      this.apiManager.getMileageWelfareRule().pipe(tap(value => {
        this.mileageWelfareRule$.next(value?.welfareRule);
        this.serviceDays$.next(value?.serviceDays);
      })).subscribe();
    }
    getCommunityRule() {
      this.apiManager.getCommunityRule().pipe(tap(value => {
        this.communityRule$.next(value);
      })).subscribe();
    }
    receiveWelfare(ruleId, type) {
      return this.apiManager.receiveWelfare(ruleId, type).pipe(tap(value => {
        this.receiveWelfare$.next(value);
      }));
    }
  }
  WelfareService.ɵfac = function WelfareService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WelfareService)(i0.ɵɵinject(APIManager), i0.ɵɵinject(UsersService));
  };
  WelfareService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: WelfareService,
    factory: WelfareService.ɵfac,
    providedIn: "root"
  });
  return WelfareService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Activity {
  toJSON() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      type: this.type,
      status: this.status,
      balance: this.balance,
      day: this.day,
      traffic: this.traffic,
      expiredAt: this.expiredAt,
      createdAt: moment.utc(this.createdAt).format('YYYY-MM-DD HH:mm:ss'),
      updatedAt: moment.utc(this.updatedAt).format('YYYY-MM-DD HH:mm:ss')
    };
  }
  isExpired() {
    return moment.utc(this.expiredAt).isBefore(moment.utc());
  }
}
class BillingCycles {}
const defaultBillingCycles = [{
  id: 'monthly',
  title: '1个月',
  description: '按月支付',
  unit: '月'
}, {
  id: 'quarterly',
  title: '1季度',
  description: '按季度支付',
  unit: '季度'
}, {
  id: 'semiannually',
  title: '半年',
  description: '按半年支付',
  unit: '半年'
}, {
  id: 'annually',
  title: '1年',
  description: '按年支付',
  unit: '年'
}];
class Campaign {}
class FlowDataRule {}
class Invitation {}
class InviteRewardInfo {}
class InviteRecord {}
class Rule {}
class Setting {
  constructor(key, value, id) {
    if (id) {
      this.id = id;
    }
    this.key = key;
    this.value = value;
  }
}
class Signup {}
class TgCode {}
class Transaction {}
class Utm {}
class Wallet {}
let DynamicDialogService = /*#__PURE__*/(() => {
  class DynamicDialogService {
    constructor(overlay, injector) {
      this.overlay = overlay;
      this.injector = injector;
    }
    open(component, config) {
      // Create overlay
      this.overlayRef = this.overlay.create(config || new OverlayConfig({
        panelClass: 'custom-overlay',
        hasBackdrop: true,
        positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
      }));
      // Create component portal
      const componentPortal = new ComponentPortal(component, null, this.injector);
      // Attach component to overlay
      const componentRef = this.overlayRef.attach(componentPortal);
      // Handle backdrop click
      this.overlayRef.backdropClick().subscribe(() => this.close());
      return componentRef.instance;
    }
    close() {
      if (this.overlayRef && this.overlayRef.hasAttached()) {
        this.overlayRef.dispose();
      }
    }
  }
  DynamicDialogService.ɵfac = function DynamicDialogService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DynamicDialogService)(i0.ɵɵinject(i1$2.Overlay), i0.ɵɵinject(i0.Injector));
  };
  DynamicDialogService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DynamicDialogService,
    factory: DynamicDialogService.ɵfac,
    providedIn: 'root'
  });
  return DynamicDialogService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of web-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AFTER_INVOICE_CANCEL, AFTER_INVOICE_DEDUCT, AFTER_INVOICE_PAID, AFTER_ORDER_CREATED, AFTER_RELOAD_FUND, AFTER_TRANSFER_FUND, AFTER_USER_LOGIN, AFTER_USER_LOGOUT, AFTER_USER_PAID, APIManager, Activity, AuthInterceptor, BillingCycles, BuyType, CHANGE_SERVICE, CORE_EVENTS, Campaign, CoreEventService, DeductionType, DynamicDialogService, FcmService, FlowDataRule, FlowDataService, Invitation, InviteRecord, InviteRewardInfo, Invoice, InvoiceDto, InvoiceItem, InvoicePage, InvoiceService, NotificationService, OPEN_DRAWER, OauthType, PayInfo, PayType, PaymentMethodService, Product, Reward, RewardInvitDto, RewardPageDto, RewardService, RewardStatus, RouterBuyType, Rule, Server, Service, ServiceService, Setting, Signup, TURN_OFF_SYSTEM_PROXY, TURN_ON_SYSTEM_PROXY, TgCode, Transaction, USER_EMAIL_VERIFIED, User, UsersService, Utm, WINDOW_SRCOLL, Wallet, WalletsService, WebCoreComponent, WebCoreModule, WebCoreService, WelfareService, defaultBillingCycles, payMethodList };
